import React from 'react'
import { storiesOf } from '@storybook/react'

import Typography from '@material-ui/core/Typography'

import GameCardBottomInfoBar from 'components/GameCard/components/GameCardBottomInfoBar'

storiesOf('GameCard/GameCardBottomInfoBar', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#DDD' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#DDD', width: 320, borderTop: '1px solid white' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <GameCardBottomInfoBar>
      <Typography
        style={{
          opacity: .5,
          fontSize: 10,
          fontWeight: 500,
          textTransform: 'uppercase',
        }}
        align="center"
        noWrap
      >
        4 / 7 friends joined
      </Typography>
    </GameCardBottomInfoBar>
  ))
